import { CASA_LEON_WEATHER_SITE } from './location.js';
import { isCloudyCode, isRainCode } from './wmo-labels.js';
import type { SkyMood, WeatherBundle, WeatherVisualState } from './weather-types.js';

function localHourInMendoza(now = new Date()): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: CASA_LEON_WEATHER_SITE.timezone,
    hour: 'numeric',
    hour12: false,
  }).formatToParts(now);
  const h = parts.find((p) => p.type === 'hour')?.value;
  return h ? Number(h) : now.getHours();
}

export function deriveWeatherVisual(bundle: WeatherBundle, effectsEnabled: boolean): WeatherVisualState {
  const code = bundle.current.weatherCode;
  const hour = localHourInMendoza(new Date(bundle.fetchedAt));
  let mood: SkyMood = 'clear';

  if (!bundle.current.isDay || hour >= 21 || hour < 6) {
    mood = 'night';
  } else if (hour >= 18 && hour < 21) {
    mood = 'dusk';
  } else if (isRainCode(code) || bundle.current.precipitationMm > 0.05) {
    mood = 'rain';
  } else if (isCloudyCode(code)) {
    mood = 'cloudy';
  } else {
    mood = 'clear';
  }

  const rainIntensity =
    mood === 'rain'
      ? Math.min(1, 0.35 + bundle.current.precipitationMm * 0.2 + (isRainCode(code) ? 0.35 : 0))
      : 0;

  return {
    mood,
    windKmh: bundle.current.windSpeedKmh,
    rainIntensity,
    effectsEnabled,
  };
}
